export const API_V1 = '/api/v1';
export const API_V1_AUTH = `${API_V1}/auth`;
export const API_V1_AUTH_LOGIN_RENEW = `${API_V1_AUTH}/login/renew`;

export const API_V1_WEB = `${API_V1}/web`;
export const API_V1_WEB_LOGIN = `${API_V1_WEB}/login`
export const API_V1_WEB_CREDIT = `${API_V1_WEB}/credits`;

export const API_V1_WEB_CARD = `${API_V1_WEB}/cards`;